import { c as _c } from "react/compiler-runtime";
import { hostedOnboardingD2pSmsMutation } from '@onefootprint/fetch-hosted';
import { useCountdown, useRequestErrorToast } from '@onefootprint/hooks';
import { Button, CopyButton, Divider, TextInput, useToast } from '@onefootprint/ui';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getLogger } from '@/idv2/utils/logger';
const {
  logError
} = getLogger({
  name: 'idv2',
  location: 'copy-or-sms-send-link'
});
const COUNTER_SECONDS = 10;
type CopyOrSmsSendLinkProps = {
  authToken?: string;
  handoffUrl?: string;
};
const CopyOrSmsSendLink = t0 => {
  const $ = _c(60);
  const {
    authToken,
    handoffUrl
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "transfer.smsTransfer.copyOrSmsSendLink"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  const [isSmsDisabled, setIsSmsDisabled] = useState(false);
  const [hasSent, setHasSent] = useState(false);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      ...hostedOnboardingD2pSmsMutation()
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const d2pSmsMutation = useMutation(t2);
  const showRequestErrorToast = useRequestErrorToast();
  const {
    toast
  } = useToast();
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      onCompleted: () => setIsSmsDisabled(false)
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    countdown,
    setSeconds
  } = useCountdown(t3);
  let t4;
  if ($[3] !== setSeconds) {
    t4 = () => {
      setIsSmsDisabled(true);
      setSeconds(COUNTER_SECONDS);
    };
    $[3] = setSeconds;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const startCountdown = t4;
  let t5;
  if ($[5] !== setSeconds || $[6] !== showRequestErrorToast) {
    t5 = error => {
      logError("Failed to send SMS for transfer page", error);
      setIsSmsDisabled(false);
      setSeconds(0);
      showRequestErrorToast(error);
    };
    $[5] = setSeconds;
    $[6] = showRequestErrorToast;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const handleSendError = t5;
  let t6;
  if ($[8] !== authToken || $[9] !== d2pSmsMutation || $[10] !== handleSendError || $[11] !== handoffUrl || $[12] !== startCountdown || $[13] !== t || $[14] !== toast) {
    t6 = () => {
      if (d2pSmsMutation.isPending || !authToken || !handoffUrl) {
        return;
      }
      d2pSmsMutation.mutate({
        body: {
          url: handoffUrl
        },
        headers: {
          "X-Fp-Authorization": authToken
        }
      }, {
        onSuccess: () => {
          setHasSent(true);
          startCountdown();
          toast({
            title: t(_temp),
            description: t(_temp2)
          });
        },
        onError: handleSendError
      });
    };
    $[8] = authToken;
    $[9] = d2pSmsMutation;
    $[10] = handleSendError;
    $[11] = handoffUrl;
    $[12] = startCountdown;
    $[13] = t;
    $[14] = toast;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const handleSendSms = t6;
  const isReady = Boolean(authToken && handoffUrl);
  let t7;
  if ($[16] !== t) {
    t7 = t(_temp3);
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t7) {
    t8 = <p className="text-body-3 text-secondary text-center">{t7}</p>;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const t9 = handoffUrl ?? "";
  const t10 = handoffUrl ?? "";
  const t11 = !handoffUrl;
  let t12;
  if ($[20] !== t10 || $[21] !== t11) {
    t12 = <CopyButton size="compact" contentToCopy={t10} disabled={t11} className="hover:!bg-senary/40 active:!bg-senary/40" />;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12 || $[24] !== t9) {
    t13 = <TextInput value={t9} size="compact" disabled={true} className="!whitespace-nowrap !overflow-hidden !text-ellipsis" suffixComponent={t12} />;
    $[23] = t12;
    $[24] = t9;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t13 || $[27] !== t8) {
    t14 = <div className="flex flex-col gap-2 w-full">{t8}{t13}</div>;
    $[26] = t13;
    $[27] = t8;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Divider />;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t) {
    t16 = t(_temp4);
    $[30] = t;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t16) {
    t17 = <span className="text-body-4 text-tertiary uppercase">{t16}</span>;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Divider />;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== t17) {
    t19 = <div className="flex items-center gap-3 w-full">{t15}{t17}{t18}</div>;
    $[35] = t17;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== t) {
    t20 = t(_temp5);
    $[37] = t;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== t20) {
    t21 = <p className="text-body-3 text-secondary text-center">{t20}</p>;
    $[39] = t20;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  const t22 = !isReady || isSmsDisabled;
  let t23;
  if ($[41] !== hasSent || $[42] !== t) {
    t23 = hasSent ? t(_temp6) : t(_temp7);
    $[41] = hasSent;
    $[42] = t;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] !== d2pSmsMutation.isPending || $[45] !== handleSendSms || $[46] !== t22 || $[47] !== t23) {
    t24 = <Button variant="secondary" fullWidth={true} disabled={t22} loading={d2pSmsMutation.isPending} onClick={handleSendSms} size="large">{t23}</Button>;
    $[44] = d2pSmsMutation.isPending;
    $[45] = handleSendSms;
    $[46] = t22;
    $[47] = t23;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== countdown || $[50] !== t) {
    t25 = countdown > 0 && <p className="text-body-3 text-quaternary text-center">{t(_temp8, {
        count: countdown
      })}</p>;
    $[49] = countdown;
    $[50] = t;
    $[51] = t25;
  } else {
    t25 = $[51];
  }
  let t26;
  if ($[52] !== t21 || $[53] !== t24 || $[54] !== t25) {
    t26 = <div className="flex flex-col gap-2 w-full">{t21}{t24}{t25}</div>;
    $[52] = t21;
    $[53] = t24;
    $[54] = t25;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  let t27;
  if ($[56] !== t14 || $[57] !== t19 || $[58] !== t26) {
    t27 = <div className="flex flex-col gap-5 mt-1 w-full">{t14}{t19}{t26}</div>;
    $[56] = t14;
    $[57] = t19;
    $[58] = t26;
    $[59] = t27;
  } else {
    t27 = $[59];
  }
  return t27;
};
export default CopyOrSmsSendLink;
function _temp($) {
  return $.resendSuccess.title;
}
function _temp2($_0) {
  return $_0.resendSuccess.description;
}
function _temp3($_1) {
  return $_1.copyInstruction;
}
function _temp4($_2) {
  return $_2.or;
}
function _temp5($_3) {
  return $_3.smsInstruction;
}
function _temp6($_4) {
  return $_4.resendSms;
}
function _temp7($_5) {
  return $_5.sendSms;
}
function _temp8($_6) {
  return $_6.subtitleWithCount;
}